import { Grid, Typography, useTheme } from '@mui/material'

import { EnhancedDropDownRHF } from '@websential/cosmic-v20'
import React from 'react'
import { Link } from 'react-router-dom';

interface IPayrollYearToDateHeaderPanel {
    yearsDDLItems: { label: string, value: string }[];
    onYearSelectionChangeHandler: (params: any) => void;
    selectedYear: any;
    onClickAddEmployeesHandler: (params: any) => void;
}
export const PayrollYearToDateHeaderPanel: React.FC<IPayrollYearToDateHeaderPanel> = ({ yearsDDLItems, onYearSelectionChangeHandler, selectedYear, onClickAddEmployeesHandler }) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                container
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                sx={{
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderBottom: 0,
                    borderRadius: "2px 2px 0 0",
                    padding: "31px 20px 1rem 20px",
                }}
                columnSpacing={2}
            >
                <Grid
                    size={{ xs: 12, sm: 4, md: 2, lg: 2, xl: 2 }}
                    sx={{
                        mt: "12px",
                        "& .dropDownWrapper": {
                            marginBottom: "10px!important",
                        }
                    }}
                >
                    <EnhancedDropDownRHF
                        selectName="yearDDLItems"
                        testId={`yearDDLItems-list`}
                        items={yearsDDLItems ?? []} 
                        onSelectionChangeHandler={onYearSelectionChangeHandler}
                        // onSelectionChangeHandler={onFrequencyChangeHandler}
                        showEmpty
                    />
                    {selectedYear && (
                        <Typography sx={{ fontSize: ".875rem", marginBottom: "40px" }}>
                            <Link
                                to="#"
                                className="no-underline"
                                style={{ color: theme.palette.primary.light }}
                                onClick={onClickAddEmployeesHandler}
                            >
                                Add / Remove Employees
                            </Link>
                        </Typography>
                    )}
                </Grid>
            </Grid>

        </>
    )
}

